import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import App from '../../components/App';

import {
  selectPathname,
  selectFaviconURL,
  selectSearch,
  selectLanguage,
  selectClient
} from '../../global-selectors';

import {
  selectBootstrapConfig,
  selectBootstrapErrors,
  selectBootstrapLoading,
  selectGetTranslationsLoading
} from '../../queries/selectors/bootstrap';

import withLoader from '../../components/withLoader';
import withTranslationProvider from '../../containers/withTranslationProvider';
import withParamsGuard from '../withParamsGuard';

const connectLanguage = compose(
  connect((state) => ({
    language: selectLanguage(state),
    client: selectClient(state)
  })),
)

const mapStateToProps = (state) => ({
  bootstrap: selectBootstrapConfig(state),
  errors: selectBootstrapErrors(state),
  isLoading: selectBootstrapLoading(state) || selectGetTranslationsLoading(state),
  pathname: selectPathname(state),
  search: selectSearch(state),
  faviconURL: selectFaviconURL(state),
  language: selectLanguage(state),
  client: selectClient(state)
});

export default compose(
  connectLanguage,
  connect(mapStateToProps),
  withTranslationProvider,
  withLoader(
    ({ isLoading }) => isLoading
  ),
  withRouter,
  withParamsGuard,
)(App);
